import React, {PureComponent} from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';

import AdditionalInfoStep from '../../RegistrationStep/AdditionalInfoStep.jsx';
import ContactDetail from '../../RegistrationStep/ContactDetail.jsx';
import CVStep from '../../RegistrationStep/CVStep.jsx';
import MeetingStep from '../../RegistrationStep/MeetingStep.jsx';
import StepLayout from '../../../../components/RegistrationSteps/StepLayout.jsx';
import PresentationStep from "../../RegistrationStep/PresentationStep.jsx";
import MeetingConfirmationStep from "../../RegistrationStep/MeetingConfirmationStep.jsx";
import MissionsStep from "../../RegistrationStep/MissionsStep.jsx";
import ValidationStep from "../../RegistrationStep/ValidationStep.jsx";
import { UserInteractionProvider } from '../../../../../shared/contexts/UserInteractionContext.jsx';

export default class CreateFreelance extends PureComponent {
  static propTypes = {
    currentStep: PropTypes.number.isRequired,
    currentUser: PropTypes.object.isRequired,
    profile: PropTypes.shape({
      freelance: PropTypes.object.isRequired,
      user: PropTypes.object.isRequired,
    }).isRequired,
    submit: PropTypes.func.isRequired,
    refresh: PropTypes.func.isRequired,
  };

  render() {
    const {currentUser, currentStep, profile, ...props} = this.props;

    const helmet = <Helmet>
      <title>Création de mon profil</title>
    </Helmet>;

    const steps = [
      {label: 'Contact', duration: '30 sec', component: ContactDetail},
      {label: 'Planifier une visio', duration: '30 sec', component: MeetingStep},
      {label: 'CV', duration: '1 min', component: CVStep},
      {label: 'Validation', duration: '1 min', component: AdditionalInfoStep},
      {label: 'RDV planifié', duration: '1 min', component: MeetingConfirmationStep},
      {label: 'Présentation', duration: '1 min', component: PresentationStep},
      {label: 'Missions', duration: '1 min', component: MissionsStep},
      {label: 'Validation', duration: '1 min', component: ValidationStep},
    ];

    const Component = steps[currentStep].component;

    return <UserInteractionProvider>
      <StepLayout
        currentStep={currentStep}
        helmet={helmet}
        steps={steps}
        title="S'inscrire - Consultant"
      >
        <Component freelance={profile.freelance} currentUser={currentUser} submit={props.submit} refresh={props.refresh} />
      </StepLayout>
    </UserInteractionProvider>;
  }
}
